<script setup lang="ts">
  import ModalSubscribePlans from '../../components/Modais/ModalSubscribePlans.vue'
</script>
<template>
  <div class="navbar-header-model">
    <tabs v-model="selectedTab">
      <tab
        :style="`width:${100 / (tabs.length + 1)}%`"
        v-for="(tab, i) in tabs"
        :key="`t${i}`"
        :val="i"
        :label="tab.name"
        :indicator="true"
      />
      <!--
      <tab :key="`t${tabs.length}`" :val="tabs[(tabs.length - 1)]?.name" :label="translate.soon" :disabled="true"
        class="disable" />
      -->
    </tabs>
    <tab-panels v-model="selectedTab" :animate="true" :swipeable="true">
      <tab-panel v-for="(tab, i) in tabs" :key="`tp${i}`" :val="i">
        <div class="row">
          <div v-for="(part, j) in tab.sessions" :key="j" class="px-2 pt-3">
            <div
              :class="
                part.block === 'false'
                  ? sessionActive == j && changeSelectedTab == i
                    ? 'card-box-active rounded-pill'
                    : 'card-box rounded-pill'
                  : 'card-box-block rounded-pill'
              "
            >
              <div
                v-if="part.block === 'true'"
                :class="part.block === 'false' ? 'part-name' : 'part-name-block w-100'"
                @click="
                  part.block === 'true'
                    ? showModalSubscribePlans(true)
                    : $emit('changeSession', { part: i, session: j })
                "
              >
                <div class="d-flex align-items-center">
                  <div class="col-5 text-center">{{ part.name }}</div>
                  <div class="col-7 text-center">
                    <button type="button" class="btn btn-outline-secondary btn-lg px-4">
                      {{ translate.subscribeNow }}
                      <font-awesome-icon
                        :icon="['fas', 'lock']"
                        size="lg"
                        style="color: #b20000; margin-left: 5px"
                      />
                    </button>
                  </div>
                </div>
              </div>
              <div
                v-else
                :class="part.block === 'false' ? 'part-name' : 'part-name-block'"
                @click="
                  part.block === 'true'
                    ? showModalSubscribePlans(true)
                    : $emit('changeSession', { part: i, session: j })
                "
              >
                {{ part.name }}
              </div>
            </div>
          </div>
        </div>
      </tab-panel>
    </tab-panels>
    <hr />
  </div>
  <ModalSubscribePlans
    @showModalSubscribePlans="showModalSubscribePlans"
    :showSubscribe="showSubscribe"
    v-if="plans != undefined && plans.length > 0"
    :plans="plans"
    :translate="translate"
  />
</template>
<script lang="ts">
  import { isMobile } from 'views/shared/utils/mobile'
  import { defineComponent } from 'vue'
  import { Tabs, Tab, TabPanels, TabPanel } from 'vue3-tabs'
  import api from '../../api'
  import { event } from 'vue-gtag'
  import { mapState, mapActions } from 'pinia'
  import { localeStore } from '../../stores/locale'
  import { planStore } from 'stores/plans'
  export default defineComponent({
    name: 'NavBarPartsModelMobile',
    components: {
      Tabs,
      Tab,
      TabPanels,
      TabPanel
    },
    emits: ['changeSession'],
    props: ['parts', 'translate', 'sessionActive', 'changeSelectedTab'],
    computed: {
      ...mapState(localeStore, ['locale']),
      ...mapState(planStore, ['plans', 'languagePlans'])
    },
    watch: {
      locale: function () {
        this.getPlans()
      },
      parts: function (value) {
        this.tabs = value
        this.selectedTab = this.changeSelectedTab
      },
      changeSelectedTab: function (value) {
        this.selectedTab = value
      }
    },
    created() {
      this.tabs = this.parts
      if (this.tabs.length) this.selectedTab = this.changeSelectedTab
      if (this.locale !== this.languagePlans) this.getPlans()
    },
    data() {
      return {
        selectedTab: '',
        isMobile: isMobile(),
        tabs: [],
        showSubscribe: false
      }
    },
    methods: {
      ...mapActions(planStore, ['setPlans']),
      getPlans() {
        api
          .get(
            `v1/home/getPlansFreeTour?language=${this.locale ?? ''}&coupon=${
              this.$route.query.coupon ?? ''
            }`
          )
          .then(({ data }) => {
            this.setPlans(data.plansFreeTour)
          })
      },
      showModalSubscribePlans(value) {
        if (value == true) this.showModalPlans('Clicar em uma sessão de fotos bloqueada - Mobile')
        this.showSubscribe = value
      },
      showModalPlans(acionador: string) {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'paywall',
          paywall: { acionador: acionador }
        })
        event('paywall2', { paywall: { acionador: acionador } })
      }
    }
  })
</script>
<style scoped>
  .tabs >>> .tab {
    padding: 15px 6px;
    font-weight: bold;
    font-size: 13px;
  }

  .tab-panels >>> .tab-panel {
    width: 98%;
  }

  .navbar-header-model .tabs > .active {
    color: #b20000;
    border-color: #b20000;
    background-color: #fafafa;
  }

  .button--more svg {
    color: #b20000;
  }

  .button--more {
    font-family: 'Exo-2';
    font-weight: bold;
    color: #898989;
    font-size: 16px;
  }

  .small svg {
    margin-right: 5px;
  }

  .card-box {
    width: 100%;
    height: 55px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    border: 1px solid #cccccc;
  }

  .card-box-active {
    width: 100%;
    height: 55px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    border: 2px solid #b20000;
  }

  .card-box-block {
    width: 100%;
    height: 55px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #cccccc;
    background-color: #eee;
  }

  .part-name {
    font-size: 16px;
    color: #b20000;
    font-family: 'Exo-2';
    font-weight: 900;
  }

  .part-name-block {
    font-size: 16px;
    color: #cccccc;
    font-family: 'Exo-2';
    padding-top: 2px;
    font-weight: 700;
  }

  .fa-lock {
    color: #b20000;
  }

  .disable {
    cursor: not-allowed;
  }

  .btn-outline-secondary {
    font-size: 15px;
    color: white;
    border-radius: 30px;
    background-color: black;
    border: none;
  }
</style>
